import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import SchedulesListings from "../Schedules/SchedulesListings";
import Statistics from "./Statistics";

const useStyles = makeStyles((theme) => ({
  container: {
    "& .statistics": {
      [theme.breakpoints.up("md")]: {
        order: 1,
      },
    },
  },
}));

export default function DashboardListings() {
  const classes = useStyles();
  return (
    <div id="Dashboard">
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12} md={5} className="statistics">
          <Statistics />
        </Grid>
        <Grid item xs={12} md={7} className="listings">
          <SchedulesListings />
        </Grid>
      </Grid>
    </div>
  );
}
